import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Screenshot = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.07422 5.08593C8.63061 4.25133 9.56731 3.75003 10.5704 3.75003H13.4296C14.4327 3.75003 15.3694 4.25133 15.9258 5.08593L16.7383 6.30473C16.9238 6.58293 17.236 6.75003 17.5704 6.75003H19C20.6569 6.75003 22 8.09318 22 9.75003V17.25C22 18.9069 20.6569 20.25 19 20.25H5C3.34315 20.25 2 18.9069 2 17.25V9.75003C2 8.09318 3.34315 6.75003 5 6.75003H6.42963C6.76399 6.75003 7.07622 6.58293 7.26168 6.30473L8.07422 5.08593ZM12 9.25003C10 9.25003 8.5 10.817 8.5 12.75C8.5 14.683 10.067 16.25 12 16.25C13.933 16.25 15.5 14.683 15.5 12.75C15.5 10.817 14 9.25003 12 9.25003Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.07422 4.83593C8.63061 4.00133 9.56731 3.50003 10.5704 3.50003H13.4296C14.4327 3.50003 15.3694 4.00133 15.9258 4.83593L16.7383 6.05473C16.9238 6.33293 17.236 6.50003 17.5704 6.50003H19C20.6569 6.50003 22 7.84318 22 9.50003V17.5C22 19.1569 20.6569 20.5 19 20.5H5C3.34315 20.5 2 19.1569 2 17.5V9.50003C2 7.84318 3.34315 6.50003 5 6.50003H6.42963C6.76399 6.50003 7.07622 6.33293 7.26168 6.05473L8.07422 4.83593ZM12 9.50003C10.067 9.50003 8.5 11.067 8.5 13C8.5 14.933 10.067 16.5 12 16.5C13.933 16.5 15.5 14.933 15.5 13C15.5 11.067 13.933 9.50003 12 9.50003Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
